module.exports = __webpack_public_path__ + "static/media/workingmemory-words-9.ca4894cf.mp3";